import {jQuery as $, lodash as _} from 'lib/shim';



const SELECTOR = '.atom-textinput';



class AtomTextinput {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._prime();
		}

		return $element;
	}



	_prime(){
		if( this._$element.hasClass('error') ){
			this._$element
				.parent('.atom-inputlabel')
				.addClass('error')
				.end()
			;
		}

		if( this._$element.is(':disabled') ){
			this._$element
				.parent('.atom-inputlabel')
				.addClass('disabled')
				.end()
			;
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new AtomTextinput(app, $this));
	});

	return $elements;
}
